import {useAxios} from '../../hooks'
const useRelacaoProdutoFornecedor = () => {

    const axios = useAxios();

    const buscarRelacoes = async (termo) => {
        const api = await axios.getApiEmitirNotas();
        const result = await api.get("/produto-fornecedor", {
            params: { termo }
        });

        return result.data;
    }


    const salvarRelacao = async (relacao) => {
        const api = await axios.getApiEmitirNotas();
        const result = await api.post("/produto-fornecedor", relacao);

        return result.data;
    }


    const removeRelacoes = async (ids) => {
        const api = await axios.getApiEmitirNotas();
        const result = await api.delete("/produto-fornecedor", {
            data: ids
        });

        return result.data;
    }

    return {buscarRelacoes, salvarRelacao, removeRelacoes};

}

export {useRelacaoProdutoFornecedor}